import Chip from "@mui/material/Chip";
import CloseIcon from "@mui/icons-material/Close";

const SelectedCaseChip = ({ chipData, handleDelete }) => {
  return (
    <Chip
      label={`${chipData.motherID} | ${chipData.name}`}
      deleteIcon={<CloseIcon />}
      {...(handleDelete ? { onDelete: () => handleDelete(chipData._id) } : {})}
      variant="outlined"
      sx={{
        transition: 'border 300ms ease-in-out',
        ...(chipData.attempt > 2 && {
          border: '2px solid red',
          borderColor: 'error.main'
        })
      }}
      aria-invalid={chipData.attempt > 2 ? "true" : undefined}
      aria-describedby={chipData.attempt > 2 ? "high-attempt-warning" : undefined}
    />
  );
};

export default SelectedCaseChip;